import { ReplaceOptionsType } from "@website/utils/replace-options/replace-options.types";
import keys from "lodash-es/keys";
import toString from "lodash-es/toString";

export const replaceOptions: ReplaceOptionsType = (text, options) =>
  toString(text).replaceAll(
    new RegExp(
      keys(options)
        .map((key) => `{${key}}`)
        .join("|"),
      "g"
    ),
    (key) => toString(options?.[key.replaceAll(/[{}]/g, "")])
  );
